var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "details-view", staticStyle: { overflow: "auto" } },
        [
          !_vm.isDialog
            ? _c(
                "div",
                [
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Cancel" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Save" },
                          on: { click: _vm.save }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveDraft")))]
                      )
                    : _vm._e(),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Save" },
                          on: { click: _vm.publishDirectly }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_PublishDirectly"))
                          )
                        ]
                      )
                    : _vm._e(),
                  !_vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Back" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("back")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
                      )
                    : _vm._e(),
                  !_vm.look && !_vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.form.status ===
                              _vm.SystemConstants.PRICE_STATUS_NORMAL.code,
                            type: "primary",
                            no: "Edit"
                          },
                          on: { click: _vm.edit }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "main-content",
              staticStyle: { width: "fit-content", "margin-top": "5px" }
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    staticStyle: { width: "900px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_EndRouteRateCode")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.form.priceNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "priceNo", $$v)
                                },
                                expression: "form.priceNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_ShippingAddressSelection"
                              ),
                              "label-width": "140px",
                              required: ""
                            }
                          },
                          [
                            _vm.isEdit
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger" },
                                    on: { click: _vm.addArea }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_AddAddress")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._l(_vm.form.priceRegions, function(
                          priceRegion,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_DeliveryAddressType"
                                    ),
                                    required: ""
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        change: function($event) {
                                          return _vm.deliveryAddressTypeChange(
                                            priceRegion
                                          )
                                        }
                                      },
                                      model: {
                                        value: priceRegion.deliveryAddressType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            priceRegion,
                                            "deliveryAddressType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "priceRegion.deliveryAddressType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            label:
                                              _vm.SystemConstants
                                                .DELIVERY_ADDRESS_TYPE_THIRD_PARTY
                                                .code
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_ThirdPartyAddress"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            label:
                                              _vm.SystemConstants
                                                .DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE
                                                .code
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_AmazonWarehouse"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            label:
                                              _vm.SystemConstants
                                                .DELIVERY_ADDRESS_TYPE_ECANG
                                                .code
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_YiCang")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          attrs: {
                                            label:
                                              _vm.SystemConstants
                                                .DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE
                                                .code
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_WalmartWarehouse"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.isEdit
                                    ? _c("i", {
                                        staticClass: "el-icon-remove",
                                        staticStyle: {
                                          color: "#f56c6c",
                                          cursor: "pointer",
                                          "margin-top": "5px",
                                          "font-size": "18px"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.delArea(index)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              priceRegion.deliveryAddressType ===
                              _vm.SystemConstants
                                .DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("SeaExport.ZIP"),
                                        required: ""
                                      }
                                    },
                                    [
                                      _c("cargo-post-code-select", {
                                        attrs: {
                                          "default-value":
                                            priceRegion.postalCode
                                        },
                                        on: {
                                          change: function(p) {
                                            _vm.postCodeChange(p, priceRegion)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              priceRegion.deliveryAddressType ===
                              _vm.SystemConstants
                                .DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: _vm.$t("SeaExport.Addr") }
                                    },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: priceRegion.address,
                                          callback: function($$v) {
                                            _vm.$set(
                                              priceRegion,
                                              "address",
                                              $$v
                                            )
                                          },
                                          expression: "priceRegion.address"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              priceRegion.deliveryAddressType ===
                                _vm.SystemConstants
                                  .DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE
                                  .code ||
                              priceRegion.deliveryAddressType ===
                                _vm.SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG
                                  .code ||
                              priceRegion.deliveryAddressType ===
                                _vm.SystemConstants
                                  .DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE.code
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_WarehouseCode2"
                                        ),
                                        required: ""
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          no: "overseaWarehouseCode",
                                          "select-type":
                                            _vm.TYPE_NAMES
                                              .basic_data_OverseaWarehouse,
                                          filterable: "",
                                          "method-params": { ifFba: true },
                                          clearable: false,
                                          "tag-name": "warehouseCode",
                                          "tag-value": "warehouseCode",
                                          "default-value":
                                            priceRegion.warehouseCode
                                        },
                                        on: {
                                          parentCallBack: function(p) {
                                            priceRegion.warehouseCode = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form",
                                {
                                  staticClass: "form-item-200",
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    inline: true,
                                    "label-position": "right"
                                  }
                                },
                                [
                                  priceRegion.deliveryAddressType ===
                                  _vm.SystemConstants
                                    .DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "margin-top": "5px"
                                          }
                                        },
                                        [
                                          _c("cargo-area", {
                                            staticStyle: {
                                              display: "inline-block"
                                            },
                                            attrs: {
                                              no: "area",
                                              country: "CN",
                                              province: priceRegion.province,
                                              city: priceRegion.city,
                                              district: priceRegion.districts,
                                              town: priceRegion.townUuid,
                                              "show-town": true,
                                              "select-width": 150
                                            },
                                            on: {
                                              "update:province": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  priceRegion,
                                                  "province",
                                                  $event
                                                )
                                              },
                                              "update:city": function($event) {
                                                return _vm.$set(
                                                  priceRegion,
                                                  "city",
                                                  $event
                                                )
                                              },
                                              "update:district": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  priceRegion,
                                                  "districts",
                                                  $event
                                                )
                                              },
                                              "update:town": function($event) {
                                                return _vm.$set(
                                                  priceRegion,
                                                  "townUuid",
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    staticStyle: { width: "603px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: !_vm.isEdit,
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_DestinationPortInfo"))
                          )
                        ]),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_POD"),
                              required: ""
                            }
                          },
                          [
                            _c(
                              "el-tabs",
                              {
                                on: {
                                  "tab-click": function($event) {
                                    _vm.form.podList = []
                                  }
                                },
                                model: {
                                  value: _vm.form.portType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "portType", $$v)
                                  },
                                  expression: "form.portType"
                                }
                              },
                              [
                                _c("el-tab-pane", {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    label: _vm.$t("CargoMsg.Cargo_Harbour"),
                                    name:
                                      _vm.SystemConstants.PORT_TYPE_SEAPORT.code
                                  }
                                }),
                                _c("el-tab-pane", {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    label: _vm.$t("CargoMsg.Cargo_Airport"),
                                    name:
                                      _vm.SystemConstants.PORT_TYPE_AIRPORT.code
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.form.portType ===
                            _vm.SystemConstants.PORT_TYPE_SEAPORT.code
                              ? _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Seaport,
                                    filterable: "",
                                    "default-multiple-value": _vm.form.podList,
                                    multiple: true
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.form.podList = p.value)
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.form.portType ===
                            _vm.SystemConstants.PORT_TYPE_AIRPORT.code
                              ? _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    "select-type":
                                      _vm.TYPE_NAMES.basic_data_Airport,
                                    filterable: "",
                                    "default-multiple-value": _vm.form.podList,
                                    multiple: true
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      return (_vm.form.podList = p.value)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("FileHistory.ProxyName") } },
                          [
                            _c("cargo-company-select", {
                              ref: "agentName",
                              attrs: {
                                no: "agentName",
                                "method-params": {
                                  active: true,
                                  subCondition: {
                                    overseaAgent: true,
                                    designationAgent: true,
                                    truckCmp: true,
                                    collectionType: "or"
                                  }
                                },
                                "default-value": _vm.form.agentName || ""
                              },
                              on: {
                                change: function(p) {
                                  _vm.form.agentName = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("Pricing.BeginDate"),
                              required: ""
                            }
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": {
                                  disabledDate: function(time) {
                                    return (
                                      _vm.form.endDate &&
                                      time.getTime() >=
                                        new Date(
                                          _vm.form.endDate.length <= 10
                                            ? _vm.form.endDate + " 00:00:00"
                                            : _vm.form.endDate
                                        ).getTime()
                                    )
                                  }
                                }
                              },
                              model: {
                                value: _vm.form.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "beginDate", $$v)
                                },
                                expression: "form.beginDate"
                              }
                            }),
                            _vm._v(" - "),
                            _c("el-date-picker", {
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                "picker-options": {
                                  disabledDate: function(time) {
                                    return (
                                      _vm.form.beginDate &&
                                      time.getTime() <=
                                        new Date(
                                          _vm.form.beginDate.length <= 10
                                            ? _vm.form.beginDate + " 00:00:00"
                                            : _vm.form.beginDate
                                        ).getTime()
                                    )
                                  }
                                }
                              },
                              model: {
                                value: _vm.form.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "endDate", $$v)
                                },
                                expression: "form.endDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: 3 },
                              model: {
                                value: _vm.form.remarks,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remarks", $$v)
                                },
                                expression: "form.remarks"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "section", staticStyle: { width: "100%" } },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("Pricing.PriceInfo")))
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_ChargeByContainerType"))
                    )
                  ]),
                  _vm.isEdit
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.addChargingItem(
                                    _vm.SystemConstants
                                      .CHARGING_ITEM_TYPE_BY_EQ_SIZE.code
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.delChargingItem(
                                    _vm.SystemConstants
                                      .CHARGING_ITEM_TYPE_BY_EQ_SIZE.code
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "section grid-wrapper" },
                    [
                      _c("cargo-ag-grid-wrapper", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "config-module": "2025050224",
                          "grid-options": _vm.chargingItemByEqSize.gridOptions,
                          "column-defs": _vm.getColumnDefsByEqSize,
                          "row-data": _vm.form.byEqSizeChargingItems,
                          "show-selected-color": false,
                          "check-sub-record": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.chargingItemByEqSize.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_ChargeNotByContainerType"))
                    )
                  ]),
                  _vm.isEdit
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.addChargingItem(
                                    _vm.SystemConstants
                                      .CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.delChargingItem(
                                    _vm.SystemConstants
                                      .CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "section grid-wrapper" },
                    [
                      _c("cargo-ag-grid-wrapper", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "config-module": "2025050225",
                          "grid-options":
                            _vm.chargingItemNotByEqSize.gridOptions,
                          "column-defs": _vm.getColumnDefsNotByEqSize,
                          "row-data": _vm.form.notByEqSizeChargingItems,
                          "show-selected-color": false,
                          "check-sub-record": false
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.chargingItemNotByEqSize.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      ),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "call-back": _vm.aiRecognitionDialog.callBack,
          title: _vm.$t("CargoMsg.CargoMsg_AIAddressRecognition"),
          placeholder: _vm.aiRecognitionDialog.placeholder
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }